import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly7B2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/7B/7.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },

  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                   Peace Begins with Us
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  CLASS: 7B     DATE: 24.09.2026
                </Typography>
               

        <Typography variant={'subtitle1'} align={'justify'}>
 Class 7B conducted a two-day assembly on Wednesday, 24 September and Thursday, 25 September 2026, centred on the theme ‘Peace Begins with Us.’ The assembly focused 
 on the importance of creating peace through our everyday words, actions and choices.
  <br></br>
  As part of the regular assembly proceedings, the Preamble to the Constitution was recited on the first day. This was followed by the introduction of the theme, the Thought for the Day and a musical presentation of “Heal the World.” Students highlighted the role 
  of kindness, respect, empathy and understanding in creating a more peaceful world.
  <br></br>
  The second day, titled ‘The Voices of Peace,’ explored five values that help us become peacemakers — Respect, Forgiveness, Empathy, Courage and Hope. Students presented each value through meaningful performances, followed by a Peace Pledge 
  encouraging everyone to choose kindness, understanding and respect in their daily lives.
  <br></br>
  The two-day assembly concluded with the message that peace is not merely something we wish 
  for, but something we create through the choices we make every day.
  <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
‘Peace Begins with Us’ — Celebrating the power of respect, forgiveness, empathy, courage and hope.
           <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 7B 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly7B2026;
